import * as borsh from "@coral-xyz/borsh"
import * as web3 from "@solana/web3.js"
import { CREATE_PROVIDER_INSTRUCTION } from "../utils/instructions";
import { BILLBOARD_PROGRAM_ID } from "../utils/constants";
import { BN } from "@coral-xyz/anchor";

const PROVIDER_ACCOUNT_SIZE = 100;

export class Provider {
    id: number
    name: string
    location: string
    publicKey: web3.PublicKey | undefined


    constructor(
        id: number, 
        name: string,
        location: string,
        publicKey?: web3.PublicKey
    ) {
        this.id = id
        this.name = name
        this.location = location
        this.publicKey = publicKey
    }

    static findAddress(authority: web3.PublicKey, providerId: number) {
        const index = new BN(providerId);
        const byteArray = index.toArray('le', 1);

        return web3.PublicKey.findProgramAddressSync(
            [Buffer.from("provider"), authority.toBuffer(), Buffer.from(byteArray)],
            new web3.PublicKey(BILLBOARD_PROGRAM_ID)
        )
    }

    borshInstructionSchema = borsh.struct([
        borsh.u8("variant"),
        borsh.str("name"),
        borsh.str("location"),
    ])

    serialize(): Buffer {
        const buffer = Buffer.alloc(PROVIDER_ACCOUNT_SIZE)
        this.borshInstructionSchema.encode(
            { ...this, variant: CREATE_PROVIDER_INSTRUCTION },
            buffer
        )
        return buffer.slice(0, this.borshInstructionSchema.getSpan(buffer))
    }

    static borshProviderSchema = borsh.struct([
        borsh.str("discriminator"),
        borsh.bool("initialized"),
        borsh.publicKey("owner"),
        borsh.str("name"),
        borsh.str("location"),
    ])

    static deserialize(buffer?: Buffer): Provider | null {
        if (!buffer) {
            return null
        }
        try {
            const slicedBuffer = buffer.slice(8);
            const { id, name, location } =
                this.borshProviderSchema.decode(slicedBuffer)
            return new Provider(id, name, location)
        } catch (e) {
            console.log("Deserialization error:", e)
            console.log(buffer)
            return null
        }
    }
}